import axios, { AxiosResponse } from "axios";
import { SEITY_HERALD_URL } from "../apiConstants";

const SECTION = "/ReportGenerator/";

// Staff report keys understood by SeityHerald's /ReportGenerator/CallReport endpoint.
// None of these require a companyID.
export type StaffReportKey = "SeityUserAccounts" | "SeityGroupsList" | "ChallengeStatus" | "SeityProAccess";

// Pulls the filename out of a Content-Disposition header, falling back when absent.
function parseFileName(contentDisposition: string | undefined, fallback: string): string {
  if (!contentDisposition) return fallback;
  const utfMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utfMatch) return decodeURIComponent(utfMatch[1]);
  const match = contentDisposition.match(/filename="?([^";]+)"?/i);
  return match ? match[1] : fallback;
}

// Calls SeityHerald and returns the streamed PDF as a blob plus its suggested filename.
export async function callReport(token: string, reportKey: StaffReportKey): Promise<{ blob: Blob; fileName: string }> {
  const url = SEITY_HERALD_URL + SECTION + "CallReport";
  const response: AxiosResponse<Blob> = await axios.get(url, {
    params: { reportKey },
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  const fileName = parseFileName(response.headers["content-disposition"], `${reportKey}.pdf`);
  return { blob: response.data, fileName };
}
